import React, { useState } from 'react';
import { useLanguage } from '../i18n/LanguageContext';

// REVAMP: clear, collapsible usage guidelines at the top of each module,
// localised via the i18n dictionary (English / 繁體中文 / 简体中文).

const ModuleGuidance: React.FC<{ moduleId?: string }> = ({ moduleId }) => {
  const { dict } = useLanguage();
  const [open, setOpen] = useState(true);
  const g = moduleId ? dict.guidance[moduleId] : undefined;
  if (!g) return null;

  return (
    <div
      className="module-guidance"
      style={{
        background: '#f4f8ff',
        border: '1px solid #d6e4ff',
        borderRadius: 10,
        padding: '12px 16px',
        margin: '0 0 16px',
      }}
    >
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        style={{
          background: 'none',
          border: 'none',
          fontWeight: 700,
          cursor: 'pointer',
          fontSize: '1rem',
          padding: 0,
        }}
      >
        ℹ️ {g.title} {open ? '▾' : '▸'}
      </button>
      {open && (
        <div style={{ marginTop: 8 }}>
          <ul style={{ margin: '0 0 8px', paddingLeft: 20 }}>
            {g.tips.map((t, i) => (
              <li key={i} style={{ margin: '4px 0' }}>
                {t}
              </li>
            ))}
          </ul>
          <small style={{ color: '#667085' }}>⏱ {g.limits}</small>
        </div>
      )}
    </div>
  );
};

export default ModuleGuidance;
